export interface DownloadSsePayload {
  downloadStatus: DownloadStatusEnum;
  url: string;
}

export enum DownloadStatusEnum {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  FAILED = 'FAILED',
}

export interface PaymentPayload {
  contractingKey: string;
  paidInstallments: number;
  paymentDate: string;
  paymentReceived: boolean;
}

export type SseStatus = 'connecting' | 'open' | 'closed';
